export default {
  imoveisEmDestaque: null,
  imovelSimilares: null,
  imovel: null,
  planos: null,
  favoritos: JSON.parse(window.localStorage.getItem('favoritos')) || [],
  imoveisFavoritos: null
}
